module.exports = __webpack_public_path__ + "img/06.003ec74c.png";